import { generateCountrySeo } from '../dynamic-seo-generator';
import { applyLocationSeo } from './seo-strategy.helpers';
import { SeoStrategyFn } from './seo-strategy.type';

/**
 * SEO strategy for country pages
 * Generates dynamic SEO from country data in cache
 */
export const CountrySeoStrategy: SeoStrategyFn = (
  seoContent,
  $document,
  cacheContent,
  countryId
) => {
  applyLocationSeo(
    countryId,
    {
      seoKey: 'countryPage',
      pageName: 'country',
      pathPrefix: '/buy-plan/plans/country',
      locationFinder: (cache, id) => {
        const country = cache.cache.singleCountries.find((c) => c._id === id);
        return country ? { name: country.name, data: country } : null;
      },
      seoGenerator: generateCountrySeo,
    },
    seoContent,
    $document,
    cacheContent
  );
};
